import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './ColumnMenu.scss';

function ColumnMenu({ children, columns }) {
    return (
        <ul
            className={styles.column}
            style={{
                columnCount: columns,
            }}
        >
            {children}
        </ul>
    );
}

ColumnMenu.propTypes = {
    children: PropTypes.node,
    columns: PropTypes.number.isRequired,
};

function ColumnMenuItem({ className, onItemClick = () => undefined, children }) {
    return (
        <li
            className={classNames(className, styles.menuItem)}
            onClick={onItemClick}
            role="menuitemradio"
        >
            {children}
        </li>
    );
}

ColumnMenuItem.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onItemClick: PropTypes.func,
};

export {
    ColumnMenu,
    ColumnMenuItem,
};

export default {
    ColumnMenu,
    ColumnMenuItem,
};
